import { List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

const itemSx = {
  mx: 1.5,
  my: 0.25,
  px: 1.75,
  py: 1,
  borderRadius: 2,
  color: "surfaces.onDark",
  transition: "background-color .2s ease, transform .2s ease",
  "& .MuiListItemIcon-root": {
    color: "surfaces.onDark",
    opacity: 0.75,
    minWidth: 38,
    transition: "opacity .2s ease, color .2s ease",
  },
  "& .MuiListItemText-primary": {
    fontWeight: 500,
    fontSize: "0.95rem",
  },
  "&:hover": {
    backgroundColor: "rgba(255,255,255,0.08)",
    transform: "translateX(2px)",
    "& .MuiListItemIcon-root": {
      opacity: 1,
      color: "accent.main",
    },
  },
};

export default function NavListPublic({ pages, onNavigate }) {
  return (
    <List sx={{ py: 0 }}>
      {pages.map((p) => (
        <ListItemButton
          key={p.to}
          onClick={() => onNavigate(p.to)}
          sx={itemSx}
        >
          <ListItemIcon>{p.icon}</ListItemIcon>
          <ListItemText primary={p.label} />
        </ListItemButton>
      ))}
    </List>
  );
}
